import { Flex, Text } from '@chakra-ui/react'
import { t } from 'i18next'
import React, { useMemo, useState } from 'react'
import { useModalState } from '~/atoms/ModalState'
import { useSettingsState } from '~/atoms/SettingsState'
import { useUserState } from '~/atoms/UserState'
import { DropdownSelect } from '~/components/shared/Dropdown/DropdownSelect'
import {
  MangoButton,
  MangoButtonVariant,
} from '~/components/shared/MangoButton'
import { MangoInput } from '~/components/shared/MangoInput'
import { MangoModal } from '~/components/shared/MangoModal'
import { TranslationKeys } from '~/locales/i18next'

import { useNewParkingLotModalStyle } from './componentStyles/NewParkingLotModal.style'

const parkingLotList = [
  {
    id: 1,
    label: 'newParkingLotModal.parking1Label',
    targetNumber: '5901',
  },
  {
    id: 2,
    label: 'newParkingLotModal.parking2Label',
    targetNumber: '5902',
  },
  {
    id: 3,
    label: 'newParkingLotModal.parking3Label',
    targetNumber: '5903',
  },
  {
    id: 4,
    label: 'newParkingLotModal.parking4Label',
    targetNumber: '5904',
  },
  {
    id: 5,
    label: 'newParkingLotModal.parking5Label',
    targetNumber: '5905',
  },
  {
    id: 6,
    label: 'newParkingLotModal.parking6Label',
    targetNumber: '5906',
  },
  {
    id: 7,
    label: 'newParkingLotModal.parking7Label',
    targetNumber: '5907',
  },
  {
    id: 8,
    label: 'newParkingLotModal.parking8Label',
    targetNumber: '5908',
  },
  {
    id: 9,
    label: 'newParkingLotModal.parking9Label',
    targetNumber: '5909',
  },
  {
    id: 10,
    label: 'newParkingLotModal.parking10Label',
    targetNumber: '5910',
  },
]

export const NewParkingLotModal = () => {
  const [selectedParkingLotIndex, setSelectedParkingLotIndex] =
    useState<number>(0)
  const [labelText, setLabelText] = useState<string | undefined>(undefined)

  const {
    parkingModal: [parkingModalState, setParkingModalState],
  } = useModalState()
  const { pbxId } = useUserState()
  const {
    settings: {
      pbx: { parkingLots },
    },
    addParkingLot,
  } = useSettingsState(pbxId)

  // Get the parking lots from 'parkingLotList' that are not already in 'parkingLots'
  const availableParkingLots = useMemo(() => {
    return parkingLotList.filter(
      (parkingLot) => !parkingLots?.find((lot) => lot.id === parkingLot.id),
    )
  }, [parkingLots])

  const selectedParkingLot = availableParkingLots[selectedParkingLotIndex]

  const handleParkingSelect = (id: number, index: number) => {
    setSelectedParkingLotIndex(index)
  }
  const handleLabelChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLabelText(e.target.value)
  }

  const handleClose = () => {
    setParkingModalState({ open: false })
    setLabelText(undefined)
    setSelectedParkingLotIndex(0)
  }
  const handleSave = () => {
    const label = labelText ?? t(selectedParkingLot.label as TranslationKeys)
    addParkingLot({
      id: selectedParkingLot.id,
      label: t(label as TranslationKeys),
      defaultLabel: t(selectedParkingLot.label as TranslationKeys),
      targetNumber: selectedParkingLot.targetNumber,
    })
    handleClose()
  }

  const styles = useNewParkingLotModalStyle()

  return (
    <MangoModal
      open={parkingModalState.open}
      onOpenChange={(details) => {
        if (!details.open) handleClose()
      }}
      header={t('newParkingLotModal.header')}
      body={
        <Flex css={styles.bodyContainer}>
          <Flex css={styles.dropdownContainer}>
            <Text css={styles.dropdownLabel}>
              {t('newParkingLotModal.parkingSpot')}
            </Text>
            <DropdownSelect
              items={availableParkingLots.map((lot) => {
                return {
                  value: lot.id,
                  content: t(lot.label as TranslationKeys),
                }
              })}
              selectedIndex={selectedParkingLotIndex}
              onSelect={handleParkingSelect}
            />
          </Flex>
          <Flex css={styles.inputContainer}>
            <Text css={styles.inputLabel}>{t('newParkingLotModal.label')}</Text>
            <MangoInput
              variant="mango"
              placeholder={t(selectedParkingLot.label as TranslationKeys)}
              value={labelText}
              onChange={handleLabelChange}
            />
          </Flex>
        </Flex>
      }
      footer={
        <Flex css={styles.footerContainer}>
          <MangoButton
            variant={MangoButtonVariant.Default_100}
            onClick={handleClose}
          >
            {t('newParkingLotModal.cancelButton')}
          </MangoButton>
          <MangoButton
            variant={MangoButtonVariant.Default_300}
            onClick={handleSave}
          >
            {t('newParkingLotModal.saveButton')}
          </MangoButton>
        </Flex>
      }
    ></MangoModal>
  )
}
